import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Button from './Button'
import { Document, HttpResponse, TaskStatusType } from './commons'
import axiosInstance from './lib/axiosInstance'

type ImageCardProps = {
  // imageUrl: string
  phaseId: string
  handleViewImage: (args: number) => void
  updateGallery: (images: string[]) => void
  title: string
  status: TaskStatusType
  issues: {
    total: number
    resolved: number
    unresolved: number
  }
}

const ImageCard: React.FC<ImageCardProps> = ({
  // imageUrl,
  phaseId,
  handleViewImage,
  updateGallery,
  title,
  status,
  issues,
}) => {

  const [images, setImages] = useState<string[]>([])

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axiosInstance.get<any, HttpResponse<Document[]>>(
          `/api/v1/Phases/GetFiles?PhaseId=${phaseId}`
        )
        setImages(response?.data?.data.map(doc => doc.url));
      } catch (error) {
        console.error('Error fetching images:', error)
      }
    }

    fetchImages().catch(console.log);

  }, [phaseId])

  return (
    <>
      <div className="relative inline-block p-2 w-full max-w-[254px] shadow rounded-sm mt-2">
        <div className="relative rounded-sm overflow-hidden">
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300 ease-in-out">
            <div className="flex flex-col items-center gap-2">
              <Button
                text="See Images"
                shade="dark"
                buttonType="default"
                type="button"
                size="tiny"
                className="w-max gap-2 text-black text-xs hover:underline"
                action={() => {
                  updateGallery(images);
                  handleViewImage(0);
                }}
              />
              <Link to={`/issue-management/${phaseId}`}>
                <Button
                  text="View Issues"
                  shade="dark"
                  buttonType="default"
                  type="button"
                  size="tiny"
                  className="w-max gap-2 text-black text-xs hover:underline"
                />
              </Link>
            </div>
          </div>
          <span style={status === 'InProgress' ? {backgroundColor: 'black', color: 'white'} : {backgroundColor: 'white'}} className="absolute left-[10px] top-[10px] bg-white w-max px-1.5 text-xs z-10">
            {status}
          </span>
          <img
            src={images[0]}
            // src="https://img.freepik.com/free-photo/modern-house-with-swimming-pool-backyard-palm-trees-concrete-walkway_1127-17501.jpg?t=st=1684244089~exp=1684244689~hmac=7e17b8cfbd18bbd9ec25b7b4bcd85c686f6fe17e4a1c02e87d5af8f6b63e12c8&w=826"
            alt={title}
            className="w-full"
          />
        </div>
        <div className="mt-5">
          <h2 className="font-semibold text-base leading-6 text-gray-800">
            {title}
          </h2>
          {/* <p className="font-normal text-xs leading-5">{description}</p> */}
          <div className="text-xs pt-1 font-normal text-xs-custom leading-5 tracking-normal text-[#848f9f]">
            {`${issues.total} issues · ${issues.resolved} resolved · ${issues.unresolved} unresolved`}
          </div>
        </div>
      </div>
      {/* Image Viewer */}
    </>
  )
}

export default ImageCard
